import {
  numberOnly,
  isEmail,
  isPhone,
  moreThanLength,
  lessThanLength,
  betweenLength,
} from '~components/common/forms/UniversalValidations.js'

export const InternScoreFormBlueprintTop = [
  { type: 'br' },
  {
    type: 'select',
    key: 'department_id',
    div: 3,
    disabled: true,
    label: '就讀系/所：',
  },
  {
    type: 'input',
    key: 'student_account',
    div: 3,
    required: true,
    disabled: true,
    label: '學號：',
    max_length: 500,
  },
  {
    type: 'input',
    key: 'student_name',
    div: 3,
    required: true,
    disabled: true,
    label: '姓名：',
    max_length: 500,
  },
  {
    type: 'input',
    key: 'internship',
    div: 2,
    required: true,
    disabled: true,
    label: '實習單位：',
    max_length: 500,
  },
  {
    type: 'input',
    key: 'work_department',
    div: 2,
    required: true,
    label: '部門別（上班班別）：',
    max_length: 500,
  },
  { type: 'hr' },
];

export const InternScoreFormBlueprintEnterprise = [
  {
    type: 'output_button',
    custom_type: 'date',
    key: 'start_time',
    div: 'auto',
    label: '實習評核期間：',
    placeholder: '開始時間',
    icon: 'date',
    square_width: '186px',
  },
  {
    type: 'output_button',
    custom_type: 'date',
    key: 'end_time',
    div: 'auto',
    class_name: 'align_self_end',
    placeholder: '結束時間',
    icon: 'date',
    square_width: '186px',
  },
  { type: 'br' },
  {
    type: 'label',
    text: '工作表現成績：（百分計分與等第計分對應標準請參考下方附件）',
  },
  {
    type: 'select_table',
    key: 'work_assess',
    required: true,
    label: '評核項目',
    select_name: '等第',
    placeholder: '請選擇等第',
    options: ['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C', 'C-', 'D', 'E', 'x'],
    values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    items: ['1.敬業精神', '2.品質效率', '3.學習熱忱', '4.團隊合群、職業倫理'],
  },
  {
    type: 'outer',
    class_name: 'intern_score_select_row',
    blocks: [
      {
        type: 'textarea',
        key: 'work_assess_other',
        div: 'grow',
        max_length: 500,
        label: '5.其他（請說明）',
        placeholder: '請輸入說明內容',
      },
      {
        type: 'select',
        key: 'work_assess_other_rank',
        div: 'auto',
        placeholder: '請選擇等第',
        square_width: '120px',
        options: ['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C', 'C-', 'D', 'E', 'x'],
        values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      },
    ],
  },
  {
    type: 'outer',
    class_name: 'intern_score_select_row',
    blocks: [
      { type: 'label', text: '實習機構評核成績' },
      {
        type: 'select',
        key: 'company_score',
        div: 'auto',
        placeholder: '請選擇等第',
        square_width: '120px',
        options: ['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C', 'C-', 'D', 'E', 'x'],
        values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      },
    ],
  },
  {
    type: 'outer',
    class_name: 'comments_outer',
    blocks: [
      {
        type: 'textarea',
        key: 'company_comments',
        required: true,
        max_length: 500,
        label: '實習機構評語與建議：',
        placeholder: '請輸入實習機構評語與建議',
      },
      {
        type: 'input',
        key: 'company_scorer',
        class_name: 'flex_row',
        max_length: 500,
        required: true,
        label: '實習機構評核者：',
      }
    ],
  },
];

export const InternScoreFormBlueprintTeacher = [
  {
    type: 'label',
    text: '學習報告成績 :（百分計分與等第計分對應標準請參考附件）',
  },
  {
    type: 'select_table',
    key: 'learn_assess',
    required: true,
    label: '評核項目',
    select_name: '等第',
    placeholder: '請選擇等第',
    options: ['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C', 'C-', 'D', 'E', 'x'],
    values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    items: ['1.報告結構內容', '2.報告與實務工作關聯性', '3.繳報告準時性', '4.學習成果'],
  },
  {
    type: 'outer',
    class_name: 'intern_score_select_row',
    blocks: [
      {
        type: 'textarea',
        key: 'learn_assess_other',
        div: 'grow',
        label: '5.其他（請說明）',
        max_length: 500,
        placeholder: '請輸入說明內容',
      },
      {
        type: 'select',
        key: 'learn_assess_other_rank',
        div: 'auto',
        placeholder: '請選擇等第',
        square_width: '120px',
        options: ['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C', 'C-', 'D', 'E', 'x'],
        values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      },
    ],
  },
  {
    type: 'outer',
    class_name: 'intern_score_select_row',
    blocks: [
      { type: 'label', text: '實習輔導教師評核成績' },
      {
        type: 'select',
        key: 'teacher_score',
        div: 'auto',
        placeholder: '請選擇等第',
        square_width: '120px',
        options: ['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C', 'C-', 'D', 'E', 'x'],
        values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      },
    ],
  },
  {
    type: 'outer',
    class_name: 'comments_outer',
    blocks: [
      {
        type: 'textarea',
        key: 'teacher_comments',
        required: true,
        label: '實習輔導教師評語與建議：',
        max_length: 500,
        placeholder: '請輸入實習輔導教師評語與建議',
      },
      {
        type: 'input',
        key: 'teacher_scorer',
        class_name: 'flex_row',
        required: true,
        label: '實習輔導教師：',
        max_length: 500,
      }
    ],
  },
];

export const InternScoreFormBlueprintAdmin = [
  { type: 'hr', class_name: 'gray_hr' },
  {
    type: 'input',
    key: 'overall_score',
    div: 'auto',
    class_name: 'flex_row',
    max_length: 500,
    required: true,
    label: '校外實習委員會綜合實習機構及實習輔導教師之評核後，該生校外實習總成績：',
    square_width: '100px',
  },
  {
    type: 'outer',
    key: 'approved_outer',
    class_name: 'flex_row',
    blocks: [
      { type: 'label', div: 'auto', text: '本案於' },
      {
        type: 'output_button',
        custom_type: 'date',
        key: 'approved_date',
        div: 'auto',
        icon: 'date',
        square_width: '176px',
      },
      { type: 'label', div: 'auto', text: '經本系、所、科本學期第' },
      {
        type: 'number',
        key: 'committee_times',
        div: 'auto',
        required: true,
        placeholder: '0',
        square_width: '70px',
      },
      { type: 'label', div: 'auto', text: '次校外實習委員會通過' },
    ],
  },
  {
    type: 'input',
    key: 'dept_manager',
    div: 'auto',
    max_length: 500,
    class_name: 'flex_row',
    required: true,
    label: '單位主管：',
    square_width: '170px',
  },
  { type: 'hr' },
];

export const InternScoreFormBlueprintTopDisabled = [
  { type: 'br' },
  {
    type: 'select',
    key: 'department_id',
    div: 3,
    disabled: true,
    label: '就讀系/所：',
  },
  {
    type: 'input',
    key: 'student_account',
    div: 3,
    required: true,
    disabled: true,
    max_length: 500,
    label: '學號：',
  },
  {
    type: 'input',
    key: 'student_name',
    div: 3,
    required: true,
    disabled: true,
    max_length: 500,
    label: '姓名：',
  },
  {
    type: 'input',
    key: 'internship',
    div: 2,
    required: true,
    max_length: 500,
    disabled: true,
    label: '實習單位：',
  },
  {
    type: 'input',
    key: 'work_department',
    div: 2,
    required: true,
    disabled: true,
    label: '部門別（上班班別）：',
    max_length: 500,
  },
  { type: 'hr' },
];

export const InternScoreFormBlueprintAdminDisabled = [
  { type: 'hr', class_name: 'gray_hr' },
  {
    type: 'input',
    key: 'overall_score',
    div: 'auto',
    max_length: 500,
    class_name: 'flex_row',
    disabled : true,
    required: true,
    label: '校外實習委員會綜合實習機構及實習輔導教師之評核後，該生校外實習總成績：',
    square_width: '100px',
  },
  {
    type: 'outer',
    key: 'approved_outer',
    class_name: 'flex_row',
    blocks: [
      { type: 'label', div: 'auto', text: '本案於' },
      {
        type: 'output_button',
        custom_type: 'date',
        key: 'approved_date',
        div: 'auto',
        disabled : true,
        icon: 'date',
        square_width: '176px',
      },
      { type: 'label', div: 'auto', text: '經本系、所、科本學期第' },
      {
        type: 'number',
        key: 'committee_times',
        div: 'auto',
        disabled : true,
        required: true,
        placeholder: '0',
        square_width: '70px',
      },
      { type: 'label', div: 'auto', text: '次校外實習委員會通過' },
    ],
  },
  {
    type: 'input',
    key: 'dept_manager',
    div: 'auto',
    class_name: 'flex_row',
    disabled : true,
    required: true,
    label: '單位主管：',
    max_length: 500,
    square_width: '170px',
  },
  { type: 'hr' },
];


export const InternScoreFormBlueprintTeacherDisabled = [
  {
    type: 'label',
    text: '學習報告成績 :（百分計分與等第計分對應標準請參考附件）',
  },
  {
    type: 'select_table',
    key: 'learn_assess',
    disabled : true,
    required: true,
    label: '評核項目',
    select_name: '等第',
    placeholder: '請選擇等第',
    options: ['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C', 'C-', 'D', 'E', 'x'],
    values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    items: ['1.報告結構內容', '2.報告與實務工作關聯性', '3.繳報告準時性', '4.學習成果'],
  },
  {
    type: 'outer',
    class_name: 'intern_score_select_row',
    blocks: [
      {
        type: 'textarea',
        key: 'learn_assess_other',
        div: 'grow',
        disabled : true,
        label: '5.其他（請說明）',
        placeholder: '請輸入說明內容',
      },
      {
        type: 'select',
        key: 'learn_assess_other_rank',
        div: 'auto',
        disabled : true,
        placeholder: '請選擇等第',
        square_width: '120px',
        options: ['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C', 'C-', 'D', 'E', 'x'],
        values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      },
    ],
  },
  {
    type: 'outer',
    class_name: 'intern_score_select_row',
    blocks: [
      { type: 'label', text: '實習輔導教師評核成績' },
      {
        type: 'select',
        key: 'teacher_score',
        div: 'auto',
        disabled : true,
        placeholder: '請選擇等第',
        square_width: '120px',
        options: ['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C', 'C-', 'D', 'E', 'x'],
        values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      },
    ],
  },
  {
    type: 'outer',
    class_name: 'comments_outer',
    blocks: [
      {
        type: 'textarea',
        key: 'teacher_comments',
        disabled : true,
        required: true,
        label: '實習輔導教師評語與建議：',
        placeholder: '請輸入實習輔導教師評語與建議',
      },
      {
        type: 'input',
        key: 'teacher_scorer',
        class_name: 'flex_row',
        disabled : true,
        required: true,
        max_length: 500,
        label: '實習輔導教師：',
      }
    ],
  },
];

export const InternScoreFormBlueprintEnterpriseDisabled = [
  {
    type: 'output_button',
    custom_type: 'date',
    disabled : true,
    key: 'start_time',
    div: 'auto',
    label: '實習評核期間：',
    placeholder: '開始時間',
    icon: 'date',
    square_width: '186px',
  },
  {
    type: 'output_button',
    custom_type: 'date',
    disabled : true,
    key: 'end_time',
    div: 'auto',
    class_name: 'align_self_end',
    placeholder: '結束時間',
    icon: 'date',
    square_width: '186px',
  },
  { type: 'br' },
  {
    type: 'label',
    text: '工作表現成績：（百分計分與等第計分對應標準請參考下方附件）',
  },
  {
    type: 'select_table',
    key: 'work_assess',
    disabled : true,
    required: true,
    label: '評核項目',
    select_name: '等第',
    placeholder: '請選擇等第',
    options: ['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C', 'C-', 'D', 'E', 'x'],
    values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    items: ['1.敬業精神', '2.品質效率', '3.學習熱忱', '4.團隊合群、職業倫理'],
  },
  {
    type: 'outer',
    class_name: 'intern_score_select_row',
    blocks: [
      {
        type: 'textarea',
        key: 'work_assess_other',
        div: 'grow',
        disabled : true,
        label: '5.其他（請說明）',
        placeholder: '請輸入說明內容',
      },
      {
        type: 'select',
        key: 'work_assess_other_rank',
        div: 'auto',
        disabled : true,
        placeholder: '請選擇等第',
        square_width: '120px',
        options: ['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C', 'C-', 'D', 'E', 'x'],
        values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      },
    ],
  },
  {
    type: 'outer',
    class_name: 'intern_score_select_row',
    blocks: [
      { type: 'label', text: '實習機構評核成績' },
      {
        type: 'select',
        key: 'company_score',
        div: 'auto',
        disabled : true,
        placeholder: '請選擇等第',
        square_width: '120px',
        options: ['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C', 'C-', 'D', 'E', 'x'],
        values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      },
    ],
  },
  {
    type: 'outer',
    class_name: 'comments_outer',
    blocks: [
      {
        type: 'textarea',
        key: 'company_comments',
        disabled : true,
        required: true,
        label: '實習機構評語與建議：',
        placeholder: '請輸入實習機構評語與建議',
      },
      {
        type: 'input',
        key: 'company_scorer',
        class_name: 'flex_row',
        disabled : true,
        required: true,
        label: '實習機構評核者：',
        max_length: 500,
      }
    ],
  },
];
